import { useMemo } from "react";

/**
 * Custom hook that returns the current application version from package.json
 * @returns Formatted version string with "v" prefix (e.g., "v0.1.0")
 */
export function useAppVersion(): string {
  return useMemo(() => {
    // Try to read from environment variable first (set during build)
    const envVersion = process.env.REACT_APP_VERSION;

    // Fallback to requiring package.json directly
    const packageVersion = envVersion || require('../../package.json').version;

    // Add "v" prefix if not already present
    return packageVersion.startsWith('v') ? packageVersion : `v${packageVersion}`;
  }, []);
}
